import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LockOnIcon } from 'tdesign-icons-react';
import { Dialog, Form, Input, MessagePlugin } from 'tdesign-react';
import { changeUserPwd } from '@/services/authService';

const { FormItem } = Form;

function ChangePassword({ visible, handleClose, info }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  useEffect(() => {
    if (visible) {
      form.reset();
    }
  }, [visible, form]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      if (fields.newPwd !== fields.newPwd2) {
        MessagePlugin.warning('新密码输入不一致！');
        return;
      }
      setSubmitting(true);
      try {
        await changeUserPwd({
          userId: info.id,
          account: info.account,
          oldPwd: fields.oldPwd,
          newPwd: fields.newPwd,
        });
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      visible={visible}
      header='修改密码'
      onClose={() => handleClose()}
      confirmBtn={{ loading: submitting, content: '提交' }}
      onConfirm={() => form.submit()}
    >
      <Form form={form} style={{ width: '80%', marginTop: 16 }} onSubmit={handleSubmit}>
        <FormItem name='oldPwd' rules={[{ required: true }]} label='旧密码'>
          <Input type='password' autocomplete='new-password' prefixIcon={<LockOnIcon />} />
        </FormItem>
        <FormItem name='newPwd' rules={[{ required: true }]} label='新密码'>
          <Input type='password' autocomplete='new-password' prefixIcon={<LockOnIcon />} />
        </FormItem>
        <FormItem name='newPwd2' rules={[{ required: true }]} label='确认新密码'>
          <Input type='password' autocomplete='new-password' prefixIcon={<LockOnIcon />} />
        </FormItem>
      </Form>
    </Dialog>
  );
}

export default connect((state) => ({
  info: state.auth.info,
}))(ChangePassword);
